import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-compass-3-line text-background-50 text-lg"></i>
                </div>
                <span className="text-lg font-semibold text-foreground-50 font-heading">
                  91n.com 官方指南
                </span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                91n.com 官方入口与使用指南导航门户，提供最新官方地址、完整功能介绍及详细使用教程。收藏本站，随时获取 91n.com 最新动态。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-50 mb-4 font-heading">内容导航</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-50 mb-4 font-heading">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
                </li>
                <li>
                  <Link to="/category/getting-started" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">入门指南</Link>
                </li>
                <li>
                  <Link to="/category/faq" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">常见问题</Link>
                </li>
                <li>
                  <Link to="/category/security-tips" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">安全须知</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-50 mb-4 font-heading">免责声明</h4>
              <p className="text-sm text-foreground-400 leading-relaxed">
                本网站为 91n.com 第三方使用指南导航门户，旨在帮助用户更好地了解和使用 91n.com 平台。本网站不隶属于 91n.com 官方，如有疑问请以官方信息为准。
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-foreground-500">
              &copy; {new Date().getFullYear()} 91n.com 官方指南. 保留所有权利.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
              <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
              <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">联系我们</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}